<div class="modal-dialog-wrapper">
  <div class="title-wrapper">
    <div class="title">Add File</div>
    <button (click)="close()">
      <mat-icon class="close-icon"> close </mat-icon>
    </button>
  </div>
  <div class="subtitle">
    These assets will appear in the File Library in this room. Optionally, attach files to room items for more
    interactivity.
  </div>
  <div class="modal-image-upload">
    <input hidden type="file" #uploader (change)="selectFile($event)" />
    @if (!fileSelected) {
      <div class="upload-empty">
        <button data-testid="uploadBtn" class="upload-btn" (click)="uploader.click()">
          <div>Upload file</div>
          <div>
            <mat-icon class="add-icon">add</mat-icon>
          </div>
        </button>
      </div>
    } @else {
      @if (uploadedFailed) {
        <div class="uploaded-file failed">
          <div class="title">Upload file</div>
          <div class="file-info">
            <div class="failed-file-example">
              <div class="file-name"><mat-icon>close</mat-icon> File Uploaded Failed</div>
            </div>
            <div>
              <button data-testid="removeBtn" (click)="removeFile()" class="secondary-button">Close</button>
            </div>
          </div>
        </div>
      } @else {
        <div class="uploaded-file">
          <div class="title">Upload file</div>
          <div class="file-info">
            <div class="file-example">
              <div><mat-icon class="file-icon" svgIcon="FILE_UPLOADED"></mat-icon></div>
              <div class="file-name"><mat-icon>check</mat-icon> {{ fileData.fileName }}</div>
            </div>
            <div>
              <button data-testid="removeBtn" (click)="removeFile()" class="secondary-button">Remove</button>
            </div>
          </div>
        </div>
      }
    }
  </div>
  <div class="footer-wrapper">
    <button
      [disabled]="!fileSelected || uploadedFailed"
      data-testid="dialogPrimaryButton"
      class="primary-button"
      mat-dialog-close
      (click)="uploadFile()"
    >
      Add File
    </button>
  </div>
</div>
